import { render, staticRenderFns } from "./uf_product_req_719.vue?vue&type=template&id=b9ccaffa&scoped=true"
import script from "./uf_product_req_719.vue?vue&type=script&lang=js"
export * from "./uf_product_req_719.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ccaffa",
  null
  
)

export default component.exports